// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__261dV","rootNoMargin":"styles_rootNoMargin__2M6kE"};